import './vue_mounts'
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});

import bootstrap from 'bootstrap';
import Chart from 'chart.js';
window.Chart = Chart;

import 'bootstrap-select/dist/js/bootstrap-select.min';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';

import feather from 'feather-icons';
window.feather = feather;

import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;

import PerfectScrollbar from 'perfect-scrollbar';
window.PerfectScrollbar = PerfectScrollbar;

import Rails from "@rails/ujs";
if (!window._rails_loaded){
  Rails.start();
}

window._bolt_data_object = window._bolt_data_object || {};

// global application scripts
// Load all scripts *after* jQuery is global
const modules = import.meta.glob('../application_scripts/*.js');
Object.values(modules).forEach((load) => {
  load().then((mod) => {
    if (typeof mod.default === 'function') mod.default();
  });
});

// load components on demand
function loadComponent(name, data) {
  import(`../components/${name}.js`)
    .then((mod) => {
      if (typeof mod.default === 'function') mod.default(data);
    })
    .catch((err) => {
      console.error(`Component "${name}" failed to load:`, err);
    });
}
window.loadComponent = loadComponent;

document.querySelectorAll('[data-appcomponent]').forEach((el) => {
  const name = el.dataset.appcomponent;
  loadComponent(name, el.dataset);
});

if (!!document.getElementById('current_website')) {
  window._current_website = document.getElementById('current_website').dataset.id;
}
